/**
 * Admin allowlist. Kept in its own dependency-free module so the web app can
 * import it for admin-route gating WITHOUT pulling the tRPC root (`./index`)
 * — and therefore `@pluck/db` / `@pluck/env/server` — into the client build.
 */
export const ADMIN_EMAILS = [
	"antoni@quassum.com",
	"antoni.silvestrovic@gmail.com",
];
